import './getPlanModal.scss';
import GetPlanModal from './components/Modals/Space/GetPlanModal';
import SubscriptionCancelModal from "./components/Modals/Profile/SubscriptionCancelModal";


$(() => {
  const getPlanModal = new GetPlanModal();
  $('body').append(getPlanModal.$modal);

  // Initialize subscription cancel modal
  const subscriptionCancelModal = new SubscriptionCancelModal();
  $('.cancel-subscription-btn').on('click', function () {
    subscriptionCancelModal.setSubscriptionId($(this).data('subscription-id'));
    subscriptionCancelModal.show();
  });
});

